import { usePostSurveyVoteBySurveyIdQuery } from '../data-access';

export const usePostSurveyVoteBySurveyId = (partnerId: string, surveyId: string) => {
	const {
		data: voteSubmitData,
		error: voteError,
		isError: isVoteError,
		isPending: isVoteProcessing,
		isSuccess: isVoteSuccessful,
		mutateAsync: submitVote
	} = usePostSurveyVoteBySurveyIdQuery(partnerId, surveyId);

	return {
		isVoteError,
		isVoteProcessing,
		isVoteSuccessful,
		submitVote,
		voteError,
		voteSubmitData
	};
};
